<template>
  <div class="collection-item">
    <div class="collection-image-container">
      <img
        v-if="item.image_url"
        :src="item.image_url"
        class="collection-image"
        @click="$emit('openImage', item)"
      />
    </div>

    <div class="collection-product-name">
      {{ item.name }}
    </div>

    <div class="collection-detail">
      <div>
        <span class="label"> สถานะ: </span>
        <span class="content">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                v-if="item.explanation && item.explanation !== '-'"
                v-bind="attrs"
                v-on="on"
                label
                x-small
                color="#ffffff"
                class="px-1 font-12"
              >
                <div
                  :class="[
                    'status-dot mr-1',
                    handleStatus(item).class,
                  ]"
                ></div>
                {{ handleStatus(item).label }}
              </v-chip>

              <v-chip
                v-else
                label
                x-small
                color="#ffffff"
                class="px-1 font-12"
              >
                <div
                  :class="[
                    'status-dot mr-1',
                    handleStatus(item).class,
                  ]"
                ></div>
                {{ handleStatus(item).label }}
              </v-chip>
            </template>
            <div>
              <div class="font-semibold">
                คำอธิบาย โดย AI
                <span class="badge-beta-white">{{ VERSION.AI }}</span>
                :
              </div>
              {{ item.explanation }}
            </div>
          </v-tooltip>
        </span>
      </div>
      <div>
        <span class="label"> โปรดักโค้ด: </span>
        <span class="content">
          {{ item.sku }}
        </span>
      </div>
      <div>
        <span class="label"> ซีเรียล: </span>
        <span class="content">
          {{ item.serial }}
        </span>
      </div>
      <div class="wrap-text-2-line">
        <span class="label"> สาขา: </span>
        <span class="content">
          {{ storeName }}
        </span>
      </div>
      <div>
        <span class="label"> พนักงาน: </span>
        <span class="content">
          {{ item.emp_name }}
        </span>
      </div>
      <div>
        <span class="label"> อัปเดต: </span>
        <span class="content">
          {{ item.created_timestamp }}
        </span>
      </div>
    </div>

    <div class="collection-action">
      <v-btn
        size="small"
        block
        depressed
        class="rounded-lg"
        @click="
          $emit('viewDetail', {
            id: item.job_id,
            storeId: item.store_id,
          })
        "
      >
        รายละเอียด
      </v-btn>

      <v-btn
        v-if="isCanUpdate && isShowChangeStatus"
        :disabled="item.answer"
        size="small"
        color="primary"
        block
        depressed
        class="rounded-lg"
        @click="$emit('submit', item)"
        >ไม่ผิดปกติ!</v-btn
      >
    </div>
  </div>
</template>

<script>
import VERSION from '@/enums/version'

export default {
  props: {
    item: Object,
    isCanUpdate: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    storeName() {
      return this.item.store_name.replace(/_/g, ' ')
    },
  },

  data() {
    return {
      VERSION,
      // Note: Hide the change status for now
      isShowChangeStatus: false,
    }
  },

  methods: {
    handleStatus(event) {
      return {
        class: !event.answer
          ? event.explanation !== '-'
            ? 'fail'
            : 'warning'
          : '',
        label: !event.answer
          ? event.explanation !== '-'
            ? 'ผิดปกติ'
            : 'ไม่ได้ประมวลผล'
          : 'ปกติ',
      }
    },
  },
}
</script>

<style lang="scss">
.collection-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-width: 100%;
  padding: 12px;
  border-radius: 14px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);

  text-align: left;

  overflow: hidden;

  .collection-image-container {
    width: 100%;
    height: fit-content;
    padding-top: 100%;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    border-radius: 6px;
    background-color: #f4f4f4;

    .collection-image {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      transition: 0.5s opacity ease-in;
    }
  }

  .collection-product-name {
    font-size: 14px;
    font-weight: bold;
    margin-top: 12px;
    color: #000;
    line-height: 20px;
    max-height: fit-content;
  }

  .collection-detail {
    display: grid;
    gap: 4px;
    padding: 12px 0;
    align-items: flex-end;

    font-size: 12px;
    margin-top: auto;
    color: #000;

    .label {
      font-weight: lighter;
    }

    .content {
      font-weight: 500;
    }
  }

  .collection-action {
    display: grid;
    gap: 12px;
  }
}

.is-loading {
  .collection-image-container {
    .collection-image {
      opacity: 0.65;
      transition: 0.5s opacity ease-in;
    }
  }
}

.wrap-text-2-line {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

.status-dot {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50%;
  display: inline-block;
  background-color: #58bb47;

  &.fail {
    background-color: #ff4d4f;
  }

  &.warning {
    background-color: #ffaa00;
  }
}

.font-12 {
  font-size: 12px !important;
}

.v-tooltip__content {
  background-color: #000 !important;
  padding: 12px;
  max-width: 280px;
  text-align: left;
}

.badge-beta-white {
  background: #fff;
  color: #000;
  padding: 0 4px;
  border-radius: 2px;
  font-size: 8px;
  vertical-align: 2px;
}
</style>
